import { render, staticRenderFns } from "./TaskDocumentModal.vue?vue&type=template&id=85c5663c&"
import script from "./TaskDocumentModal.vue?vue&type=script&lang=js&"
export * from "./TaskDocumentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports